
export type ExpertLabel =
  | "STRONG_RELATED"
  | "WEAK_RELATED"
  | "UNCERTAIN";

export type Review = {
  pair_id: string;
  reviewer_id: string;
  label: ExpertLabel;
};

export function setLocalReview(
  reviews: Review[],
  next: Review,
): Review[] {
  return [
    ...reviews.filter(
      (row) =>
        !(
          row.pair_id === next.pair_id &&
          row.reviewer_id === next.reviewer_id
        ),
    ),
    next,
  ].sort((a, b) =>
    `${a.pair_id}|${a.reviewer_id}`.localeCompare(
      `${b.pair_id}|${b.reviewer_id}`,
    ),
  );
}

export function coverage(
  pairIds: string[],
  reviews: Review[],
  reviewerId: string,
): { reviewed: number; total: number } {
  const seen = new Set(
    reviews
      .filter((row) => row.reviewer_id === reviewerId)
      .map((row) => row.pair_id),
  );
  return {
    reviewed: pairIds.filter((pairId) => seen.has(pairId)).length,
    total: pairIds.length,
  };
}
